<!--
 * @Author: yuanweijiang
 * @Date: 2024-09-09 11:45:08
 * @LastEditors: yuanweijiang
-->
<template>
  <el-popconfirm title="确认删除吗？" popper-class="scopedName" :hide-icon="true" @confirm="confirmDelete">
    <i
      class="iconfont icon-shanchu-bukexuan iconDefault"
      slot="reference"
      title="删除"
      style="margin-left: 10px; font-size: 14px; font-weight: 700"
    ></i>
  </el-popconfirm>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: {
    handleData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    confirmDelete() {
      this.$emit('handleDel', this.handleData)
    }
  }
}
</script>

<style></style>
